document.addEventListener('DOMContentLoaded', function() {
    var customSubmitBtn = document.querySelector('.custom_external_btn');

    if(customSubmitBtn)
    {
        var realSubmitBtn = document.querySelector('.custom-submit-btn');

        if(realSubmitBtn)
        {
            customSubmitBtn.addEventListener('click', function () {
                realSubmitBtn.click();
            });
        }
    }
});